<template>
  <div class="file-cust-gid">
    <div v-for="detection in detections" :key="detection.files[0]?.id">
      <FilePreview :file="detection?.files[0]" :set_id="detection.detection_set_id" image_type="detection">
        <div>
          <div style="width: 50%; float: left;">
            <i v-if="detection.actions.delete" @click="$emit('sendForDelete', detection.id)"
              class="fa fa-trash fa-danger fa-lg" />
          </div>
          <router-link style="width: 50%; float: left;" v-if="detection.actions.update"
            :to="{ name: 'DetectionUpdate', params: { project_id: detection.project_id, detection_set_id: detection.detection_set_id, id: detection.id } }">
            <a><i class="mx-1 fa fa-edit fa-lg" /></a>
          </router-link>
        </div>
      </FilePreview>
    </div>
  </div>
</template>
<script>
import FilePreview from '@/views/Shared/FilePreview.vue';

export default {
  props: {
    detections: {
      value: Array,
      required: true,
    },
  },
  components: {
    FilePreview,
  },
};
</script>
